<section class="main-body">
  <p [hidden]="true"> Version: {{version}}</p>
  <app-header *ngIf="showHeader"></app-header>

  <div class="modal fade" id="sessiontimeout" [ngClass]="{'show' : IsSessionExpired, 'hide':!(IsSessionExpired)}"
    [ngStyle]="{'display': IsSessionExpired ? 'block' : 'none'}" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title w-100 d-block">
            Session Timeout !
            <a (click)="closeTimeoutPopup();" class="fs-12 text-underline float-right pt-1 text-white"
              data-dismiss="modal"><i class="fas fa-times"></i></a>
          </h5>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <p class="fs-14 text-center">
                  Your session has expired due to inactivity. Please click here to <a href="javascript:void(0)"
                    (click)="openLoginForm()">Login</a>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <section id="mainContent" class="pageContentMain">

    <router-outlet></router-outlet>
    <app-loader />
    <app-footer *ngIf="showFooter"></app-footer>

    <!-- Auto Modal Popover -->
    <div *ngIf="showHeader && isRegProfile" class="modal self-hcp-backdrop fade"
      [ngClass]="{'show' : (!authService.isUserLoggedIn() && (!utilityService.isProfileSelected() || utilityService.isProfileSelection) && isRegProfile)}"
      id="autoModal" data-backdrop="true" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      [ngStyle]="{'display': (!authService.isUserLoggedIn() && (!utilityService.isProfileSelected() || utilityService.isProfileSelection) && isRegProfile) ? 'block' : 'none'}">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Welcome to {{utilityService.getPortalName()}} Information Portal
            </h5>
          </div>
          <div class="modal-body popup-scroll">
            <p class="fs-13 text-center">This is a resource dedicated to provide scientifically balanced medical information on Duchesnay’s products.</p>
            <ng-container *ngFor="let userprofile of portalProfiles">
              <button type="button" class="btn btn-block btn-primary mt-3 fs-14" data-dismiss="modal"
                (click)="NavigatePortalUser(userprofile, true);">{{userprofile.NAME}}</button>
            </ng-container>
            
            <p class="fs-13 pt-3 attest-popup">You can also contact the Duchesnay Medical Information department via email at 
              <a href="mailto:medicalinfo@duchesnay.com?subject=Medical%20Information%20Request" class="d-inline-block">medicalinfo&#64;duchesnay.com</a>. 
            </p>
            
            <!-- <p class="fs-13 pt-3 attest-popup">Please mail <a href="mailto:medicalinfo@duchesnay.com?subject=Medical%20Information%20Request"
              class="d-inline-block">medicalinfo&#64;duchesnay.com</a> to contact a Medical Information Healthcare Professional directly.</p> -->
              
            <p class="fs-13 pt-3 attest-popup">
              Please review our <a href="{{footerElements?.Terms_Of_Use_Link}}" target="_blank">Terms
                of Use</a> and <a href="{{footerElements?.Privacy_Link}}" target="_blank">Privacy Statement</a>
               before continuing. 
               <!-- <a href="https://www.scimaxglobal.com/products/scimax-platform/"
                target="_blank">Click here</a> to learn about {{utilityService.getPortalName()}} products and view the
              current prescribing information. -->
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Non HCP redirection popup -->
    <div *ngIf="showHeader" class="modal self-hcp-backdrop fade" [ngClass]="{'show': utilityService.isNonHCP}"
      id="nonhcpredirection" data-backdrop="false" tabindex="-1" role="dialog"
      [ngStyle]="{'display': utilityService.isNonHCP ? 'block' : 'none'}" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title w-100 d-block">
              Welcome to Patient/Caregiver Page
            </h5>
          </div>
          <div class="modal-body pt-0">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 text-center mt-3 px-0">
                  <h3 class="fs-14">
                    You are about to leave {{utilityService.getPortalName()}} Medical
                    <P>Information Portal</P>
                  </h3>
                  <p class="fs-14 pt-3">Please <a href="https://www.scimaxglobal.com/">Click Here </a> to Continue to
                    page 1</p>
                  <p class="fs-14 pt-3">Please <a href="https://www.techsolcorp.com/">Click Here </a> to Continue to
                    page 2</p>
                </div>
                <button type="button" class="btn btn-primary btn-block text-center mt-3 fs-14" data-dismiss="modal"
                  (click)="onBack();">Back</button>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div *ngIf="utilityService.IsNotHcpAction" class="modal self-hcp-backdrop fade show z-index-3"
      id="nonhcpredirection2" [ngStyle]="{'display': utilityService.IsNotHcpAction ? 'block' : 'none'}"
      data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title w-100 d-block">
              Welcome to Patient/Caregiver Page
            </h5>
          </div>
          <div class="modal-body pt-0">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 text-center mt-3 px-0">
                  <h3 class="fs-14">
                    You are about to leave {{utilityService.getPortalName()}} Medical
                    <P>Information Portal</P>
                  </h3>
                  <p class="fs-14 pt-3">Please <a href="https://www.scimaxglobal.com/">Click Here </a> to Continue to
                    page 1</p>
                  <p class="fs-14 pt-3">Please <a href="https://www.techsolcorp.com/">Click Here </a> to Continue to
                    page 2</p>
                </div>
                <button type="button" class="btn btn-primary btn-block text-center mt-3 fs-14" data-dismiss="modal"
                  (click)="onNonHCPClose();">Close</button>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div *ngIf="showHeader" class="privacyPrompt pt-4" [ngStyle]="{'display':cookieToogle ? 'block' : 'none'}">
      <div class="row">
        <div class="col-md-7 col-sm-7">
          <p>
            This portal uses cookies. By using our portal without changing your cookie settings you agree to our use of
            cookies as described in our 
            <a href="{{footerElements?.Contact_Us_Link}}" target="_blank">Cookie Policy.</a>
          </p>
        </div>
        <div class="col-md-5 col-sm-5">
          <div class="text-right mbl-100 cookieSettings">
            <a href="javascript:void(0);" (click)="allowCookies()">Accept</a>
            <a href="javascript:void(0)" (click)="closeCookies()">Reject</a>
          </div>
        </div>
      </div>

    </div>

  </section>
  <app-toast-message></app-toast-message>
</section>
<!-- </block-ui> -->